module.exports = __webpack_public_path__ + "static/media/icon_play.491e3fb8.png";